import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

export default function CareMomentsCaregiverRank(props: {
  amount?: number;
  icon: React.ReactNode;
  direction?: "left" | "right";
  size?: "xs" | "sm" | "md" | "lg";
}) {
  return (
    <Root data-direction={props.direction} data-size={props.size ?? "md"}>
      <Icon>{props.icon}</Icon>
      {props.amount !== undefined && (
        <Content data-direction={props.direction ?? "right"}>
          <Amount>
            $<strong>{props.amount}</strong>
          </Amount>
          <Description>{translate(STRINGS.PER_HOUR)}</Description>
        </Content>
      )}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &[data-size="xs"] {
    --icon-size: 32px;
  }

  &[data-size="sm"] {
    --icon-size: 40px;
    --font-size-amount-prefix: 10px;
    --font-size-amount: 14px;
    --font-size-description: 10px;
    --content-py: 6px;
    --content-px: 6px;
  }

  &[data-size="md"] {
    --icon-size: 48px;
    --content-py: 8px;
    --content-px: 10px;
  }

  &[data-size="lg"] {
    --icon-size: 56px;
    --font-size-amount-prefix: 14px;
    --font-size-amount: 24px;
    --font-size-description: 14px;
    --content-py: 8px;
    --content-px: 16px;
  }

  &[data-direction="left"] {
    flex-direction: row-reverse;
  }
`;

const Icon = styled.div`
  color: var(--tw-blue-600);
  position: relative;
  z-index: 1;
  display: flex;

  svg {
    width: var(--icon-size, 56px);
    height: var(--icon-size, 56px);
    border-radius: var(--icon-size, 56px);
  }
`;

const Content = styled.div`
  background: white;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: var(--content-py) var(--content-px);
  width: fit-content;
  display: flex;
  flex-direction: column;

  &[data-direction="left"] {
    margin-inline-end: calc(var(--icon-size) / -2);
    padding-inline-end: calc(var(--icon-size) / 2.2 + var(--content-px));
  }

  &[data-direction="right"] {
    margin-inline-start: calc(var(--icon-size) / -2);
    padding-inline-start: calc(var(--icon-size) / 2.2 + var(--content-px));
  }
`;

const Amount = styled.p`
  margin: 0;
  font-size: var(--font-size-amount-prefix, 12px);
  line-height: 1;

  strong {
    font-size: var(--font-size-amount, 18px);
  }
`;

const Description = styled.p`
  margin: 0;
  font-size: var(--font-size-description, 12px);
  line-height: 1;
`;

CareMomentsCaregiverRank.Root = Root;
CareMomentsCaregiverRank.Icon = Icon;
CareMomentsCaregiverRank.Content = Content;
CareMomentsCaregiverRank.Amount = Amount;
